export default "__VITE_ASSET__D0R$PLYZ__"